export default {
  title: 'Registos do sistema',
  source: 'Ligado à instância: {{instanceId}} · Ficheiro: {{fileName}}',
  instances: 'Instâncias',
  localInstance: '{{instanceId}} (ligada)',
  instanceLost: 'Esta instância deixou de enviar o seu registo (desligada ou inacessível)',
  status: {
    connecting: 'A ligar...',
    connected: 'Em direto',
    disconnected: 'Desligado',
  },
  searchPlaceholder: 'Filtrar linhas...',
  levels: {
    error: 'Erro',
    warn: 'Aviso',
    info: 'Info',
    debug: 'Depuração',
  },
  httpRequests: 'Pedidos HTTP',
  httpRequestsTitle: 'Mostrar ou ocultar as linhas que registam os pedidos HTTP atendidos pelo servidor',
  maxLines: 'Máx. linhas',
  pause: 'Pausar',
  resume: 'Retomar ({{count}} novas)',
  export: 'Exportar',
  exportTitle: 'Descarregar todas as linhas carregadas (sem aplicar os filtros) para um ficheiro de texto',
  clear: 'Limpar',
  reconnect: 'Voltar a ligar',
  jumpToLatest: 'Ir para as mais recentes',
  fileNotFound: 'Instância {{instanceId}}: ficheiro de registo {{fileName}} não encontrado, a aguardar a sua criação',
  linesCount: 'A mostrar {{visible}} de {{total}} linhas',
  markers: {
    rotated: 'ficheiro de registo rodado',
    skipped: 'demasiadas linhas escritas: algumas linhas foram ignoradas',
    truncated: 'linhas mais antigas não carregadas',
  },
}
